import "core-js/modules/es.array.concat.js";
import config from '@/core/config';
export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return "".concat(pageTitle, " - ").concat(config.appName);
  }
  return "".concat(config.appName);
}